<template>
  <div class="c-drawerConnect fill-height">
    <router-link to="/">
      <v-img
        class="c-drawerConnect__logo"
        :src="require('@/assets/logo-adveroo-blue.svg')"
        contain
        height="18"
        position="left center"
      />
    </router-link>

    <ui-step-list :items="items" />

    <div class="c-drawerConnect__ico">
      <v-img
        v-if="icon"
        :src="require(`@/assets/${icon}`)"
        contain
        height="40"
      />
    </div>
  </div>
</template>

<script>
import router from "@/router"

const items = [
  // {
  //   title: "Registrace",
  //   route: "/register",
  //   submenu: [],
  // },
  {
    title: "Propojení s Facebookem",
    route: "/onboard/connect",
    submenu: [
      {
        title: "Propojení s Facebookem",
        route: "/onboard/connect/facebook",
      },
      {
        title: "Facebook Business Manager",
        route: "/onboard/connect/business-manager",
      },
      {
        title: "Reklamní účet",
        route: "/onboard/connect/ad-account",
      },
      {
        title: "Facebook pixel",
        route: "/onboard/connect/pixel",
      },
    ],
  },
  {
    title: "Platební plán",
    route: "/onboard/subscription",
    submenu: [],
  },
  {
    title: "Platební informace",
    route: "/onboard/payment-info",
    submenu: [],
  },
  {
    title: "Doplnění profilu",
    route: "/onboard/additional-info",
    submenu: [],
  },
]

function getIcon() {
  if (router.currentRoute.name?.includes("onboard.connect")) {
    return "ico-connect.svg"
  }
  return "ico-money.svg"
}

export default {
  props: {
    menuItem: String,
    submenuItem: String,
  },
  data() {
    return {
      items,
      icon: getIcon(),
    }
  },
}
</script>

<style scoped>
.c-drawerConnect {
  padding: 43px 24px 39px 40px;
  position: relative;
  background: url("../../../assets/drawer-shapes.svg") left bottom / 331px 133px
    no-repeat;
}

.c-drawerConnect__logo {
  margin-bottom: 48px;
}

.c-drawerConnect__ico {
  position: absolute;
  bottom: 72px;
  left: 64px;
}
</style>
